import React, { memo } from "react"
import PropTypes from "prop-types"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import CloseIcon from "@material-ui/icons/Close"
import styles from "./styles.js"

const ScannerContainerHeader = ({
	handleScannerClose,
	scanning,
	isMaster,
	masterUuid,
	masterDetails,
	nodeControllerUuidToDisplay,
	userMessage,
	clearFeedbackHandler,
}) => {
	const styling = styles()

	return (
		<div className={styling.scannerModalHeader}>
			<div className={styling.scannerModalHeaderChild}>
				{scanning ? (
					<ArrowBackIcon onClick={handleScannerClose} className={styling.scannerModalHeaderBackBtn} />
				) : isMaster && masterDetails[masterUuid] ? (
					`${masterDetails[masterUuid].name ?? "N/A"}`
				) : nodeControllerUuidToDisplay ? (
					`Node: ${nodeControllerUuidToDisplay ?? "N/A"}`
				) : (
					"N/A"
				)}
			</div>
			<div className={styling.scannerModalHeaderCenter}>
				<div className={styling.messageContainer}>
					{!!userMessage.message && (
						<>
							<CloseIcon className={styling.closeMessageBtn} onClick={clearFeedbackHandler} />
							<p className={userMessage.type === "error" ? styling.warningMessageError : styling.warningMessageSuccess}>
								Response: {userMessage.message}
							</p>
						</>
					)}
				</div>
			</div>
			<div className={styling.scannerModalHeaderChild}></div>
		</div>
	)
}

export default memo(ScannerContainerHeader)

ScannerContainerHeader.propTypes = {
	handleScannerClose: PropTypes.func.isRequired,
	scanning: PropTypes.bool.isRequired,
	isMaster: PropTypes.bool.isRequired,
	masterUuid: PropTypes.string,
	masterDetails: PropTypes.object.isRequired,
	nodeControllerUuidToDisplay: PropTypes.string.isRequired,
	userMessage: PropTypes.object.isRequired,
	clearFeedbackHandler: PropTypes.func,
}
